module.exports = __webpack_public_path__ + "img/insta-mob.4063f237.svg";